import PropTypes from "prop-types";
import { useState } from "react";
import writeExcelFile from "write-excel-file/browser";
import ModalGeneric from "./ModalGeneric";

const Excel = ({ element, filename, sheets, count, total }) => {
  const [openModal, setOpenModal] = useState(false);

  const checkIfModalShouldBeDisplay = () => {
    if (!total || !count) {
      return false;
    }

    return count < total;
  };

  const onExport = () => {
    if (checkIfModalShouldBeDisplay()) {
      setOpenModal(true);
    } else {
      handleExport();
    }
  };

  const handleExport = async () => {
    if (!sheets || sheets.length === 0) {
      return;
    }

    const sheetsData = sheets.map((sheet) => {
      if (!sheet.data || sheet.data.length === 0) {
        return { sheet: sheet.name, data: [] };
      }

      const headers = Object.keys(sheet.data[0]);
      const headerRow = headers.map((header) => ({
        value: header,
        fontWeight: "bold",
      }));
      const dataRows = sheet.data.map((row) =>
        headers.map((header) => ({ value: row[header] ?? null })),
      );

      return {
        sheet: sheet.name,
        data: [headerRow, ...dataRows],
      };
    });

    await writeExcelFile(sheetsData).toFile(filename);

    setOpenModal(false);
  };

  if (element) {
    return (
      <>
        {openModal && (
          <ModalGeneric
            id="someElementsHiddenModal"
            modalTitle="Ufullstendig rapport"
            open={openModal}
            openModal={() => setOpenModal(true)}
            closeModal={() => setOpenModal(false)}
            submit={handleExport}
            closeButtonText="Avbryt"
            submitButtonText="Fortsett allikevel"
          >
            <p>
              Noen rader mangler! Trykk "Avbryt", gå nederst i tabellen og utvid
              "Rader per side" til "Alle" før du prøver igjen.
            </p>
          </ModalGeneric>
        )}
        {element(onExport)}
      </>
    );
  }

  return null;
};

Excel.propTypes = {
  tableTitle: PropTypes.string,
  filename: PropTypes.string,
  element: PropTypes.func,
  sheets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.object),
    }),
  ),
  total: PropTypes.number,
  count: PropTypes.number,
};

export default Excel;
